export default {
  namespaced: true,
  state: {
    notifications: [],
    isActive: false,
    notificationType: null,
  },
  mutations: {
    SET_NOTIFICATION: (state, notifications) => {
      state.notifications = notifications.messages;
      state.notificationType = notifications.notificationType;
    },
    DISPLAY_NOTIFICATION: (state) => {
      state.isActive = true;
    },
    HIDE_NOTIFICATION: (state) => {
      state.isActive = false;
    },
  },
  actions: {
    SETNOTIFICATION: (store, notification) => {
      store.commit('SET_NOTIFICATION', notification);
      store.commit('DISPLAY_NOTIFICATION');
    },
    DISPLAYNOTIFICATION: (store) => {
      store.commit('DISPLAY_NOTIFICATION');
    },
    HIDENOTIFICATION: (store) => {
      store.commit('HIDE_NOTIFICATION');
    },
  },
  getters: {
    getNotifications: state => state.notifications,
    isOpen: state => state.isActive,
    getNotificationType: state => state.notificationType,
  },
};
